import httpClient from "Api/httpClient";

const END_POINT = "/options_categories";

const getOptionsCategories = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getOptionsCategory = (category_id) => {
    if (!category_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + category_id;
    return httpClient.get(SINGLE_END_POINT);
};

const getOptions = (payload) => {
    if (!payload) return;

    let body = "";
    if (payload.body) body = payload.body;

    const SINGLE_END_POINT = "/options?slug=" + body.slug + "&sort_by=" + body.sort_by + (body.with_trashed ? "&with_trashed=1" : "");
    return httpClient.get(SINGLE_END_POINT);
};

const printOptionsCategory = (category_id) => {
    if (!category_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?category_id=" + category_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createOptionsCategories = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateOptionsCategories = (payload, category_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + category_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteOptionsCategories = (category_id) => {
    const DELETE_END_POINT = END_POINT + "/" + category_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export {
    getOptionsCategories,
    getOptions,
    getOptionsCategory,
    printOptionsCategory,
    createOptionsCategories,
    updateOptionsCategories,
    deleteOptionsCategories,
};
